import { getUnreadCounts } from 'store/slices/status-unread-counts';

/**
 * מתזמן רענון מוני תצוגות: debounce עורפי + single-flight.
 * נקרא מאירועי socket ה-company-wide בלבד (message:new, updateChatUserUnread) —
 * ראה האפיון, סעיף 2.1.
 */

const DEBUG = Boolean((import.meta as any).env?.VITE_DEBUG_UNREAD_COUNTS);
const DEBOUNCE_MS = 300;

let timer: ReturnType<typeof setTimeout> | null = null;
let inFlight = false;
let dirty = false;
let pendingTriggers = 0;

export function scheduleUnreadCountsRefresh(source: string): void {
  pendingTriggers += 1;
  if (DEBUG) {
    console.debug(`[unread-counts] refresh scheduled · source=${source} · pending=${pendingTriggers}`);
  }
  if (timer) clearTimeout(timer);
  timer = setTimeout(runRefresh, DEBOUNCE_MS);
}

async function runRefresh(): Promise<void> {
  timer = null;

  // single-flight: אם בקשה כבר בתעופה — נסמן dirty ונריץ פעם נוספת בסיום
  if (inFlight) {
    dirty = true;
    return;
  }

  if (DEBUG && pendingTriggers > 1) {
    console.debug(`[unread-counts] coalesced ${pendingTriggers} triggers into 1 request`);
  }
  pendingTriggers = 0;
  inFlight = true;
  try {
    await getUnreadCounts();
  } finally {
    inFlight = false;
    if (dirty) {
      dirty = false;
      scheduleUnreadCountsRefresh('dirty-followup');
    }
  }
}
